export type Option<T> =
  | { kind: 'some'; value: T }
  | { kind: 'none' };

export function Some<T>(value: T): Option<T> {
  return { kind: 'some', value };
}

export function None<T>(): Option<T> {
  return { kind: 'none' };
}

export function isSome<T>(option: Option<T>): option is { kind: 'some'; value: T } {
  return option.kind === 'some';
}

export function isNone<T>(option: Option<T>): option is { kind: 'none' } {
  return option.kind === 'none';
}


export function expect<T>(option: Option<T>, errorMessage: string): T {
  if (isSome(option)) {
    return option.value;
  } else {
    throw new Error(errorMessage);
  }
}
